import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import reservationRemarkActions from 'actions/reservation_remark.actions';
import userActions from 'actions/user.actions';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import _ from 'lodash';

//import avatar from "assets/img/faces/face-3.jpg";

class EditReservationRemark extends Component {
  constructor(props) {
    super(props);
    this.props.dispatch(reservationRemarkActions.getReservationRemark(this.props.match.params.id));

    this.state = {
      submitted: false,
      reservation_remark: {
        note: '',
        user: '',
        userInput: '',
        reservation: ''
      },
      suggestions: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.userSelected = this.userSelected.bind(this);
    this.onUsersFetchRequested = this.onUsersFetchRequested.bind(this);
    this.onUsersClearRequested = this.onUsersClearRequested.bind(this);
    this.fetchUsersWithDebounce = _.debounce(this.onUsersFetchRequested, 1500);
  }

  handleChange(e) {
    const { name, value } = e.target;
    let reservation_remark = this.state.reservation_remark;
    reservation_remark[name] = value;
    this.setState({ reservation_remark: reservation_remark });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    const { dispatch } = this.props;
    if (this.state.reservation_remark.user && this.state.reservation_remark.note && this.state.reservation_remark.reservation) {
      dispatch(
        reservationRemarkActions.update(
          this.props.match.params.id,
          {
            user: this.state.reservation_remark.user,
            note: this.state.reservation_remark.note,
            reservation: this.state.reservation_remark.reservation
          }
        )
      );
    }
  }

  userSelected(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) {
    let reservation_remark = this.state.reservation_remark;
    reservation_remark.user = suggestionValue;
    reservation_remark.userInput = suggestion.firstName + " " + suggestion.lastName;
    this.setState({reservation_remark: reservation_remark});
  }

  onUsersFetchRequested = ({ value }) => {
    if(this.state.reservation_remark.user && value) {
      if(_.find(this.state.suggestions, {id: this.state.reservation_remark.user, firstName: value.split(" ")[0], lastName: value.split(" ")[1]})) {
        this.setState({suggestions: []});
        return;
      }
    }
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    if(inputLength === 0) {
      this.setState({suggestions: []});
      return;
    }
    if(inputLength >= 3) {
      if(inputValue.indexOf(" ") > -1) {
        this.props.dispatch(userActions.getUsers({filtered: JSON.stringify([{id: 'firstName', value: inputValue.split(" ")[0]}, {id: 'lastName', value: inputValue.split(" ")[1]}])}));
      }
      else {
        this.props.dispatch(userActions.getUsers({filtered: JSON.stringify([{id: 'firstName', value: inputValue}])})); 
      }
    }
  };

  onUsersClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  componentWillUpdate(props) {
    if(props.reservation_remark && JSON.stringify(this.props.reservation_remark) !== JSON.stringify(props.reservation_remark)) {
      let reservation_remark = props.reservation_remark;
      reservation_remark.userInput = reservation_remark.user.firstName + " " + reservation_remark.user.lastName;
      reservation_remark.user = reservation_remark.user.id;
      this.setState({reservation_remark: reservation_remark});
    }
    if(props.error && !this.props.error) {
      this.props.addNotification({type: 'error', message: props.error});
    }
    if(props.success && !this.props.success) {
      this.props.addNotification({type: 'success', message: 'Reservation Remark updated successfully'});
    }
    if(props.users && JSON.stringify(props.users) !== JSON.stringify(this.state.suggestions)) {
      this.setState({suggestions: props.users});
    }
  }

  render() {
    const { submitted, reservation_remark, suggestions } = this.state;
    const { loading } = this.props;
    const getSuggestionValue = suggestion => suggestion.id;
    const renderSuggestion = suggestion => (
      <div>
        {suggestion.firstName + " " + suggestion.lastName}
      </div>
    );
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Edit Reservation Remark"
                content={
                  <form name="profileForm" onSubmit={this.handleSubmit}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>User</ControlLabel>
                          <Autosuggest
                            suggestions={suggestions}
                            onSuggestionsFetchRequested={this.fetchUsersWithDebounce}
                            onSuggestionsClearRequested={this.onUsersClearRequested}
                            getSuggestionValue={getSuggestionValue}
                            renderSuggestion={renderSuggestion}
                            onSuggestionSelected={this.userSelected}
                            inputProps={{
                              name: 'userInput',
                              value: reservation_remark.userInput,
                              placeholder: 'User',
                              onChange: this.handleChange,
                              className: 'form-control'
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Reservation</ControlLabel>
                          <FormControl placeholder="Reservation" disabled={true} bsClass= "form-control" name="reservation" value={reservation_remark.reservation} onChange={this.handleChange}></FormControl>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="error-row">
                      <Col md={6}>{submitted && !reservation_remark.user && <div className="error">User is required</div>}</Col>
                      <Col md={6}>{submitted && !reservation_remark.reservation && <div className="error">Reservation is required</div>}</Col>
                    </Row>
                    <FormInputs
                      ncols={["col-md-12"]}
                      proprieties={[
                        {
                          label: "Remark",
                          componentClass: "textarea",
                          bsClass: "form-control",
                          placeholder: "Remark",
                          value: reservation_remark.note,
                          name: 'note',
                          onChange: this.handleChange
                        }
                      ]}
                    />
                    <Row className="error-row">
                      <Col md={12}>{submitted && !reservation_remark.note && <div className="error">Remark is required</div>}</Col>
                    </Row>
                    <Button bsStyle="info" disabled={loading} fill type="submit">
                      Update Reservation Remark
                    </Button>
                    {loading && submitted && 
                      <img alt="" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    }
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loading, item, error, success } = state.reservationRemarks;
  return {
    loading, reservation_remark: item, error, success, users: state.users.items
  };
}
 
export default connect(mapStateToProps)(EditReservationRemark);
